"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterIcon = function TwitterIcon() {
  return _react2.default.createElement(
    "svg",
    {
      className: "quiver-twitter-icon",
      xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19"
    },
    _react2.default.createElement("path", {
      d: "M15.65762,3.07187247 C14.98406,2.30608364 14.0243,1.81817281 12.96212,1.80049295\n        C10.92272,1.76654739 9.26914996,3.48985727 9.26914996,5.64945031 C9.26914996,5.9559486\n        9.30181998,6.25482911 9.36481997,6.54174642 C6.29563998,6.34266781 3.57449,4.74445785\n        1.75316,2.33534495 C1.43528,2.9126229 1.25312,3.5873346 1.25312,4.31009801 C1.25312,\n        5.67835065 1.90508,6.89266512 2.89598,7.60964678 C2.29064,7.58292203 1.72121,7.399671\n        1.22333,7.09904465 C1.22297,7.11547643 1.22297,7.13191213 1.22297,7.14863617 C1.22297,\n        9.0594062 2.49593,10.6623942 4.18532,11.0358084 C3.87545,11.123614 3.54919999,11.1695662\n        3.21242,11.167333 C2.97446,11.165755 2.74307,11.1393665 2.51762,11.091985 C2.98750999,\n        12.6590104 4.35127999,13.802484 5.96731999,13.8402927 C4.70344999,14.8894307 3.11117,\n        15.5142648 1.38092,15.5106955 C1.08284,15.5100806 0.788900001,15.4908195 0.5,15.4537626\n        C2.13431,16.575132 4.07543,17.2280238 6.16090997,17.2285709 C12.95348,17.2303531 16.66805,\n        11.319156 16.66805,6.19191392 C16.66805,6.02369447 16.66436,5.85637488 16.65734,5.68986318\n        C17.37887,5.1522284 18.00491,4.4781539 18.5,3.70842197 C17.83778,4.00693752 17.12597,\n        4.20519819 16.37906,4.28836249 C17.14145,3.81915198 17.7270799,3.06819633 18.00275,\n        2.16766535 C17.28914,2.60041708 16.49885,2.91075712 15.65762,3.07187247 L15.65762,\n        3.07187247 Z"
    })
  );
};

exports.default = TwitterIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TwitterIcon/TwitterIcon.js
// module id = 693
// module chunks = 11